import { VariantProps } from "class-variance-authority";
import * as React from "react";
import { createLink, LinkComponent } from "@tanstack/react-router";

import { cn } from "@/lib/utils";
import { buttonVariants } from "./button";

export interface ButtonLinkProps
  extends React.AnchorHTMLAttributes<HTMLAnchorElement>,
    VariantProps<typeof buttonVariants> {}

const ButtonLinkComponent = React.forwardRef<
  HTMLAnchorElement,
  ButtonLinkProps
>(({ className, variant, size, ...props }, ref) => {
  return (
    <a
      className={cn(buttonVariants({ variant, size, className }))}
      ref={ref}
      {...props}
    />
  );
});
ButtonLinkComponent.displayName = "ButtonLink";

const CreatedButtonLinkComponent = createLink(ButtonLinkComponent);

export const ButtonLink: LinkComponent<typeof ButtonLinkComponent> = (
  props,
) => {
  return <CreatedButtonLinkComponent preload="intent" {...props} />;
};